import Select from './Select'
import './Select.sass'

export default Select
